import { siteMetadata } from "../../gatsby-config";

// Google exige des URLs absolues dans les données structurées (JSON-LD).
// Préfixe le domaine du site quand l'URL passée est relative ; renvoie "" si vide.
export const toAbsoluteUrl = (url) =>
  !url ? "" : /^https?:\/\//.test(url) ? url : `${siteMetadata.siteUrl}${url}`;
